type GetRouteParams<T extends string> = T extends `:${infer Name}/${infer Rest}`
  ? Record<Name, string | number> & GetRouteParams<Rest>
  : T extends `:${infer OnlyName}`
    ? Record<OnlyName, string | number>
    : T extends `${string}/${infer MoreRest}`
      ? GetRouteParams<MoreRest>
      : Record<never, never>;

// `FilledRoute<"/land/search/saved/:sub/:searchName", {sub: '123', searchName: 'testSearch'}>` should return `/land/search/saved/123/testSearch`
type FilledRoute<
  Route extends string,
  Params extends Record<string, string | number>
> = Route extends `${infer First}/${infer Rest}`
  ? First extends `:${infer ParamName}`
    ? ParamName extends keyof Params
      ? `${Params[ParamName]}/${FilledRoute<Rest, Params>}`
      : never
    : `${First}/${FilledRoute<Rest, Params>}`
  : Route extends `:${infer ParamName}`
    ? ParamName extends keyof Params
      ? `${Params[ParamName]}`
      : never
    : Route;

export function fillRoute<
  const Route extends string,
  const Params extends GetRouteParams<Route> = GetRouteParams<Route>,
>(route: Route, params: Params): FilledRoute<Route, Params> {
  const routeSegments = route.split('/');
  return routeSegments
    .map((routeSegment) => {
      if (!routeSegment.startsWith(':')) return routeSegment;
      const paramName = routeSegment.replace(/^:/, '') as keyof typeof params;

      return `${params[paramName]}`;
    })
    .join('/') as never;
}
